/* eslint-disable react/forbid-prop-types */
import React, { Component } from "react";
import { v4 as uuid } from "uuid";
import SimpleReactValidator from "simple-react-validator";
import { Button, FormLabel, ComboBox, FormGroup, Loading, TextArea, TextInput, DataTableSkeleton, Checkbox } from "carbon-components-react";
import Add16 from "@carbon/icons-react/lib/add/16";
import Edit16 from "@carbon/icons-react/lib/edit/16";
import Error16 from "@carbon/icons-react/lib/error/16";
import Data16 from "@carbon/icons-react/lib/data--1/16";
import Send16 from "@carbon/icons-react/lib/send/16";
import Close16 from "@carbon/icons-react/lib/close/16";
import Delete16 from "@carbon/icons-react/lib/delete/16";
import Task16 from "@carbon/icons-react/lib/task/16";
import Report16 from "@carbon/icons-react/lib/report/16";
import ExportDoc16 from "@carbon/icons-react/lib/document--export/16";
import Archive16 from "@carbon/icons-react/lib/archive/16";
import CheckmarkOutline16 from "@carbon/icons-react/lib/checkmark--outline/16";
import PropTypes, { object } from "prop-types";
import Save16 from "@carbon/icons-react/lib/save/16";
import { Information16 } from "@carbon/icons-react";
import { api, me } from "../../helpers/api/api";
import { showNotification } from "../../helpers/notification/BaseNotification";
import { getSuccess, getError, entitiesLabels, apioperation, STATUS, AuditSection, TEAM_LEADER } from "../../helpers/Constants";
import WorkSiteMultiSelect from "./common/WorkSiteMultiSelect";
import ProjectMultiSelect from "./common/ProjectMultiSelect";
import AuditorComboBox from "./common/AuditorComboBox";
import CompanyComboBox from "./common/CompanyComboBox";
import DivisionComboBox from "./common/DivisionComboBox";
import SectionComboBox from "./common/SectionComboBox";
import AuditScopeMultiSelect from "./common/AuditScopeMultiSelect";
import AuditTypeComboBox from "./common/AuditTypeComboBox";
import AuditTargetDropDown from "./common/AuditTargetDropDown";
import { CanExecuteAction, IsEditable, IsEnabled } from "../../helpers/authorization/Policies";
import NewAttachmentTable, { attachmentTablePrivacyText } from "../common/NewAttachmentTable";
import PageBreadCrumb, { StatusTag } from "../../helpers/PageBreadCrumb";
import { HistoryTable } from "../../helpers/HistoryTable";
import EmailChips from "../../helpers/EmailChips";
import AuditRepository from "../../helpers/api/AuditRepository";
import ReasonForSamplingMultiSelect from "./common/ReasonForSamplingMultiSelect";
import { AppContext } from "../../helpers/context/AppContext";
import { Online } from "../common/OnLineOffLine";
import { WFActionModal } from "../common/WFActionModal";
import { Menu, Item } from "../../helpers/scrolling/ScrollingMenuItem";
import { ScrollingProvider, Section } from "../../lib/react-scroll-section/src/index";
import OnBehalfDivisionComboBox from "./common/OnBehalfDivisionComboBox";
import OnBehalfWorkSiteComboBox from "./common/OnBehalfWorkSiteComboBox";
import OnBehalfProjectComboBox from "./common/OnBehalfProjectComboBox";
import ProcessMultiSelect from "./common/ProcessMultiSelect";
import FunctionMultiSelect from "./common/FunctionMultiSelect";
import AuditSubcontractor from "./common/AuditSubcontractor";
import DownLoadButton from '../common/FileDownloadButton';

const AuditAttachmentTableMainDescription = "Upload only one file at 3 Mb or less; please check the file attached before to submit the report because afterwards it is not possible to modify it"
export default class AuditProgram extends Component {
	constructor(props) {
		super(props);
		this.onSelectCompanyChange = this.onSelectCompanyChange.bind(this);
		this.onSelectDivisionChange = this.onSelectDivisionChange.bind(this);
		this.onSelectAuditTypeChange = this.onSelectAuditTypeChange.bind(this);
		this.onSelectSectionChange = this.onSelectSectionChange.bind(this);
		this.onSelectWorkSiteChange = this.onSelectWorkSiteChange.bind(this);
		this.onSelectScopeChange = this.onSelectScopeChange.bind(this);
		this.handleSelectedYear = this.handleSelectedYear.bind(this);
		this.handleSelectedMonth = this.handleSelectedMonth.bind(this);
		this.onSelectProjectChange = this.onSelectProjectChange.bind(this);
		this.onSelectDistributionListChange = this.onSelectDistributionListChange.bind(this);
		this.onSelectAuditorChange = this.onSelectAuditorChange.bind(this);
		this.onSelectTargetChange = this.onSelectTargetChange.bind(this);
		this.onSelectProcessChange = this.onSelectProcessChange.bind(this);
		this.onSelectFunctionChange = this.onSelectFunctionChange.bind(this);
		this.onAuditScopeObjectiveChange = this.onAuditScopeObjectiveChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.monthToString = this.monthToString.bind(this);
		this.monthToNumber = this.monthToNumber.bind(this);
		this.saveAudit = this.saveAudit.bind(this);
		this.updateAudit = this.updateAudit.bind(this);
		this.renderLoadingModal = this.renderLoadingModal.bind(this);
		this.onSelectReasonChange = this.onSelectReasonChange.bind(this);
		this.onOtherHSEIssuesTextChange = this.onOtherHSEIssuesTextChange.bind(this);
		this.onSelectMailCCChange = this.onSelectMailCCChange.bind(this);
		this.repository = new AuditRepository();
		this.validator = new SimpleReactValidator({
			validators: {
				emails: {
					// name the rule
					message: "The :attribute must be a valid email address list semicolon separated",
					rule: (val, params, validator) =>
						validator.helpers.testRegex(
							val,
							// eslint-disable-next-line no-useless-escape
							/^(([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)(\s*;\s*|\s*$))+$/i
						) && params.indexOf(val) === -1,
					required: true, // optional
				},
			},
		});

		this.months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
		this.state = {
			newAudit: {
				id: uuid(),
				auditCode: null,
				projectAuditCode: null,
				auditRemote: false,
				company: null,
				onBehalfCompany: null,
				division: {},
				onBehalfDivision: {},
				section: {},
				type: {},
				projects: [],
				onBehalfProject: {},
				worksites: [],
				onBehalfWorkSite: null,
				auditor: {},
				scopes: [],
				reasonsForSampling: [],
				otherHSEIssues: null,
				sequence: 0,
				month: null,
				year: null,
				target: {},
				distributionList: null,
				mailCC: null,
				isHistoryModalOpen: false,
				idStatus: null,
				functions: [],
				processes: [],
				subContractors: [],
				auditScopeAndObjective: "",
				planAttachments: []
			},
			isSubmitted: true,
			isApprovalModalOpen: false,
			approvalModalAction: "",
			approver: null,
			approvalStartDate: null,
			approvalEndDate: null,
			isLoadingApproverOptions: true,
			approvalValidationMessages: [],
			approvers: [],
			selectedData: [],
			approverRole: "",
			withApprover: true,
			isLoadingWFOperation: false,
			approvalNotesRequired: false,
			editingAuditorDisabled: true,
			editingPlanAttachmentDisabled: true,
			isLoadingNotificationFile: false
		};
		this.statuses = STATUS;
		const year = new Date().getFullYear();
		this.years = Array.from(new Array(5), (val, index) => (index + year).toString());
	}

	async componentDidMount() {
		this.setState({ isSubmitted: true });
		const audit = await this.getAudit(this.props.match.params.id);
		//const userDivision = await this.repository.getAuditors(); //B1_Audit_Module_Optimization
		await this.setState({
			audit,
			//userDivision, //B1_Audit_Module_Optimization
			newAudit: {
				id: audit?.id || uuid(),
				auditCode: audit?.auditCode || null,
				maskedValue: audit?.maskedValue || null,
				isMasked: audit?.isMasked||null,
				projectAuditCode: audit?.projectAuditCode || null,
				auditRemote: audit?.auditRemote || false,
				company: audit?.company || null,
				onBehalfCompany: audit?.onBehalfCompany || null,
				division: audit?.division || {},
				onBehalfDivision: audit ? audit.onBehalfDivision || {} : null,
				section: audit?.auditSection || {},
				type: audit?.auditType || {},
				projects: audit?.projects || [],
				onBehalfProject: audit?.onBehalfProject || {},
				worksites: audit?.workSites || [],
				onBehalfWorkSite: audit?.onBehalfWorkSite || null,
				auditor: audit?.auditors.find((a) => a.teamLeader == true) || {},
				scopes: audit?.scopes || [],
				reasonsForSampling: audit?.reasonsForSampling || [],
				otherHSEIssues: audit?.otherHSEIssues,
				sequence: audit?.sequence || 0,
				month: this.monthToString(audit?.referenceMonth),
				year: audit?.referenceYear.toString() || null,
				target: audit?.target || {},
				distributionList: audit?.distributionList || null,
				mailCC: audit?.mailCC || null,
				isHistoryModalOpen: false,
				idStatus: audit?.idStatus || null,
				functions: audit?.functions || [],
				processes: audit?.processes || [],
				subContractors: audit?.subContractors || [],
				auditScopeAndObjective: audit?.auditScopeAndObjective || "",
				//RITM0531919
				idDataApprover: audit?.idDataApprover || "",
				idCompiler: audit?.idCompiler || "", //RITM1064131
				//---------
				planAttachments: audit?.planAttachments || []
			},
			checkListCompilerChanged: false,
			isSubmitted: false,
			// editingDisabled: audit
			//   ? audit.idStatus === this.statuses.Consolidated
			//   : false
			editingDisabled: audit ? !IsEditable("Audit", "Planning", this.context.user, audit.status.id, "All", audit) : false,
			editingAuditorDisabled: audit ? audit.checkList?.idStatus > 2 || !IsEditable("Audit", "Planning", this.context.user, audit.status.id, "Auditor", audit) : false,
			editingWorkSiteDisabled: audit ? audit.checkList?.notificationForm.sendedOn != null || !IsEditable("Audit", "Planning", this.context.user, audit.status.id, "WorkSite", audit) : false,
			editingDateDisabled: audit ? !IsEditable("Audit", "Planning", this.context.user, audit.status.id, "Reference Date", audit) : false,
			editingPlanAttachmentDisabled: false,
		});
	}

	monthToString = (monthNumber) => this.months[monthNumber - 1] || "";

	monthToNumber = (monthName) => this.months.indexOf(monthName) + 1;

	showButtonHistory = () => (
		<Button className="action-button-modal" kind="secondary" renderIcon={Information16} onClick={() => this.openModalHistory()}>
			History
		</Button>
		//  <Information16 onClick={() => this.openModalHistory()}></Information16>
	);

	openModalHistory = () => {
		this.setState({ isHistoryModalOpen: true });
	};

	closeModalHistory = () => {
		this.setState({ isHistoryModalOpen: false });
	};

	getAudit = async (id) => {
		let audit = null;

		try {
			if (id) audit = await this.repository.getAudit(id);
			//   audit.auditorsNoSaipem.map((el) => {
			//     audit.auditors.push({ ...el, id: uuid() });
			//   });

			//   audit.auditeeNoSaipem.map((el) => {
			//     audit.auditees.push({ ...el, id: uuid() });
			//   });
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.REPORT, apioperation.GET));
		}
		return audit;
	};

	getStatusActions = (user) => (
		<Online>
			<>
				{CanExecuteAction("Audit", "Planning", user, this.state.newAudit.idStatus, "Submit", this.state.newAudit) ? (
					<Button renderIcon={Send16} onClick={() => this.batchActionClick("Submit", "Submit", "Data Approver", true, false, this.state.newAudit)}>
						Submit Program
					</Button>
				) : null}

				{/* RITM0565449 */}
				{CanExecuteAction("Audit", "Planning", user, this.state.newAudit.idStatus, "Approve", this.state.newAudit) ? (
					<Button renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Approve", "Approve", "Division Manager", true, false, this.state.newAudit)}>
						Approve Program
					</Button>
				) : null}

				{/* RITM0565449 */}
				{CanExecuteAction("Audit", "Planning", user, this.state.newAudit.idStatus, "Consolidate", this.state.newAudit) ? (
					<Button renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("Consolidate", "Consolidate", null, false, false, this.state.newAudit)}>
						Consolidate Program
					</Button>
				) : null}

				{/* RITM0565449 */}
				{CanExecuteAction("Audit", "Planning", user, this.state.newAudit.idStatus, "RejectConsolidate", this.state.newAudit) ? (
					<Button renderIcon={CheckmarkOutline16} onClick={() => this.batchActionClick("RejectConsolidate", "RejectConsolidate", null, false, true, this.state.newAudit)}>
						Reject Consolidate
					</Button>
				) : null}

				{CanExecuteAction("Audit", "Planning", user, this.state.newAudit.idStatus, "Reject", this.state.newAudit) ? (
					<Button renderIcon={Error16} onClick={() => this.batchActionClick("Reject", "Reject", null, false, true, this.state.newAudit)}>
						Reject Program
					</Button>
				) : null}

				{CanExecuteAction("Audit", "Planning", user, this.state.newAudit.idStatus, "Delete", this.state.newAudit) ? (
					<Button renderIcon={Delete16} onClick={() => this.batchActionClick("Delete", "Delete", null, false, false, this.state.newAudit)}>
						Delete Program
					</Button>
				) : null}

				{this.state.newAudit.idStatus != null ?
				<DownLoadButton
					onError={(error) => {
						showNotification.error(getError(error, entitiesLabels.AUDIT_PLAN, apioperation.DOWNLOAD));
					}}
					size="default"
						iconDescription="Download Audit Program"
						title="Download Audit Program"
					renderIcon={ExportDoc16}
					apiUrl={`/audit/${this.state.newAudit.id}/exportplan`}
					fileName={`Audit_Programme_${this.state.newAudit.auditCode}.zip`}
					onDownLoadStart={() => {
						this.setState({
						isLoadingNotificationFile: true,
						});
					}}
					onDownLoadEnd={() => {
						this.setState({
						isLoadingNotificationFile: false,
						});
					}}
					>
					Download Audit Program
				</DownLoadButton>
				: null}
			</>
		</Online>
	);

	onSelectCompanyChange = (selectedItem) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.company = selectedItem || null;
			newAudit.projects = [];
			return { newAudit };
		});
	};

	onBehalfCompanyChange = (selectedItem) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.onBehalfCompany = selectedItem || null;
			newAudit.onBehalfProject = null;
			return { newAudit };
		});
	};

	onSelectDivisionChange = async (selectedItem) => {
		const distributionList = selectedItem ? await this.repository.getProgramDistributionList(selectedItem.id) : [];
		const toList = distributionList
			.filter((address) => {
				if (address.recipientType === "To") return true;
				return false;
			})
			.map((address) => address.emailAddress)
			.join(",");
		const ccList = distributionList
			.filter((address) => {
				if (address.recipientType === "Cc") return true;
				return false;
			})
			.map((address) => address.emailAddress)
			.join(",");
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.division = selectedItem || {};
			newAudit.worksites = [];
			newAudit.auditor = {};
			newAudit.distributionList = toList;
			newAudit.mailCC = ccList;
			return { newAudit };
		});
	};

	onBehalfDivisionChange = async (selectedItem) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.onBehalfDivision = selectedItem || {};
			newAudit.onBehalfWorkSite = null;
			return { newAudit };
		});
	};

	onSelectAuditTypeChange = (selectedItem) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.type = selectedItem || {};
			return { newAudit };
		});
	};

	onSelectSectionChange = (selectedItem) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.section = selectedItem || {};
			if (newAudit.section.id?.toLowerCase() !== AuditSection.QUALITY.id?.toLowerCase() || newAudit.section.id?.toLowerCase() !== AuditSection.HSEQ.id?.toLowerCase() ||newAudit.section.id?.toLowerCase() !== AuditSection.HSE.id?.toLowerCase()) {
				newAudit.functions = [];
				newAudit.processes = [];
				this.validator.message("processes", newAudit.processes[0], "");
			}
			newAudit.scopes = [];
			newAudit.type = {};
			return { newAudit };
		});
	};

	onSelectWorkSiteChange = (selectedItems) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.worksites = selectedItems || [];
			return { newAudit };
		});
	};

	onBehalfWorkSiteChange = (selectedItem) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.onBehalfWorkSite = selectedItem;
			return { newAudit };
		});
	};

	onSelectProjectChange = (selectedItems) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.projects = selectedItems || [];
			return { newAudit };
		});
	};

	onBehalfProjectChange = (selectedItem) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.onBehalfProject = selectedItem;
			return { newAudit };
		});
	};

	onSelectAuditorChange = (selectedItem) => {
		const selectedAuditor = selectedItem;
		let compilerChanged = false;
		if (selectedItem) {
			compilerChanged = this.state.audit && this.state.audit.checkList && this.state.audit.checkList.idCompiler !== selectedAuditor.id;
			selectedAuditor.teamLeader = true;
			selectedAuditor.role = TEAM_LEADER;
		}
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.auditor = selectedAuditor || {};
			return { newAudit };
		});
		if (compilerChanged == false) {
			this.validator.message("Reasons for change", this.state.newAudit.reasonsForChange, "");
		}
		this.setState({ checkListCompilerChanged: compilerChanged });
	};

	onSelectTargetChange = (selectedItem) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.target = selectedItem || {};
			if (newAudit.target.name !== "Subconctractor/Supplier") {
				newAudit.subContractors = [];
				this.validator.message("Subconctractor/Supplier", newAudit.subContractors[0], "");
			}
			return { newAudit };
		});
	};

	onSelectDistributionListChange = (e) => {
		const val = e;
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.distributionList = val;
			return { newAudit };
		});
	};

	onSelectMailCCChange = (e) => {
		const val = e;
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.mailCC = val;
			return { newAudit };
		});
	};

	onSelectReasonChange = (selectedItems) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.reasonsForSampling = selectedItems || [];
			newAudit.otherHSEIssues = newAudit.reasonsForSampling.findIndex((el) => el.name === "Any other HSE issues") !== -1 ? newAudit.otherHSEIssues : "";
			return { newAudit };
		});
	};

	onOtherHSEIssuesTextChange = (text) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.otherHSEIssues = text;
			return { newAudit };
		});
	};

	onReasonForChangeChange = (e) => {
		const val = e.target.value;
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.reasonsForChange = val;
			return { newAudit };
		});
	};

	onProjectAuditCodeChange = (e) => {
		const val = e.target.value;
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.projectAuditCode = val;
			return { newAudit };
		});
	};

	onAuditRemoteChange = (e) => {
		const val = e;
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.auditRemote = val;
			return { newAudit };
		});
	};

	onSelectSubContractorsChange = (e) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.subContractors = e || []
			return { newAudit };
		});
	};

	handleSelectedMonth = (selectedItem) => {
		let month;
		try {
			month = selectedItem.selectedItem;
		} catch (error) {
			month = null;
		}
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.month = month;
			return { newAudit };
		});
	};

	handleSelectedYear = (selectedItem) => {
		let year;
		try {
			year = selectedItem.selectedItem;
		} catch (error) {
			year = null;
		}
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.year = year;
			return { newAudit };
		});
	};

	onSelectScopeChange = (selectedItems) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.scopes = selectedItems || [];
			return { newAudit };
		});
	};

	onAuditScopeObjectiveChange(event) {
		const { value } = event.currentTarget;
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.auditScopeAndObjective = value;
			return { newAudit };
		});
	}

	onSelectProcessChange = (selectedItems) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.processes = selectedItems || [];
			return { newAudit };
		});
	};

	onSelectFunctionChange = (selectedItems) => {
		this.setState((prevState) => {
			const newAudit = { ...prevState.newAudit };
			newAudit.functions = selectedItems || [];
			return { newAudit };
		});
	};

	renderLoadingModal = () => {
		const show = this.state.isSubmitted;
		return show && <Loading active withOverlay description="Saving..." />;
	};

	saveAudit = async (item) => {
		try {
			this.setState({ isSubmitted: true });
			item.id = uuid();
			const { data } = await api.post("/audit", item);
			showNotification.success(`${entitiesLabels.SUCCESS}`, `${entitiesLabels.AUDIT} ${getSuccess(data.auditCode, apioperation.POST)}`);
			await this.repository.updateCachedAuditList(data, data.referenceYear);
			await this.repository.updateCachedAuditPlan(item);
			this.props.history.push("/listofaudit?isBack");
			return data;
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.AUDIT, apioperation.POST));
			return null;
		} finally {
			this.setState({ isSubmitted: false });
		}
	};

	updateAudit = async (item) => {
		try {
			this.setState({ isSubmitted: true });
			await api.put("/audit/plan", item);
			showNotification.success(`${entitiesLabels.SUCCESS}`, ` ${entitiesLabels.AUDIT} ${getSuccess(item.auditCode, apioperation.PUT)}`);
			await this.repository.updateCachedAuditList(item, item.referenceYear);
			await this.repository.updateCachedAuditPlan(item);
			return this.props.history.push("/listofaudit?isBack");
		} catch (error) {
			showNotification.error(`${entitiesLabels.ERROR}`, getError(error, item.auditCode, apioperation.PUT));
			return null;
		} finally {
			this.setState({ isSubmitted: false });
		}
	};

	handleSubmit = async (event) => {
		event.preventDefault();
		if (this.validator.allValid()) {
			const newAuditDTO = {
				id: this.state.newAudit.id,
				maskedValue: this.state.audit?.maskedValue || false,
				isMasked: this.state.audit?.isMasked || false,
				auditCode: this.state.audit?.auditCode || null,
				projectAuditCode: this.state.newAudit.projectAuditCode || null,
				auditRemote: this.state.newAudit.auditRemote,
				referenceYear: parseInt(this.state.newAudit.year, 10),
				referenceMonth: this.monthToNumber(this.state.newAudit.month),
				idAuditType: this.state.newAudit.type.id,
				auditType: this.state.newAudit.type,
				idDivision: this.state.newAudit.division.id,
				division: this.state.newAudit.division,
				idCompany: this.state.newAudit.company?.id || null,
				company: this.state.newAudit.company || null,
				idAuditSection: this.state.newAudit.section.id,
				auditSection: this.state.newAudit.section,
				idAuditTarget: this.state.newAudit.target.id,
				target: this.state.newAudit.target,
				distributionList: this.state.newAudit.distributionList,
				mailCC: this.state.newAudit.mailCC,
				workSites: this.state.newAudit.worksites.map((elem) => elem),
				projects: this.state.newAudit.projects.map((elem) => elem),
				scopes: this.state.newAudit.scopes.map((elem) => elem),
				reasonsForSampling: this.state.newAudit.reasonsForSampling.map((elem) => elem),
				otherHSEIssues: this.state.newAudit.otherHSEIssues,
				auditors: [1].fill(this.state.newAudit.auditor),
				idCompiler: this.state.audit?.idCompiler,
				idDataApprover: this.state.audit?.idDataApprover,
				idDivisionManager: this.state.audit?.idDivisionManager,
				idStatus: this.state.audit?.idStatus,
				status: this.state.audit?.status || null,
				compiler: this.state.audit?.compiler || null,
				createdBy: this.state.audit?.createdBy || null,
				createdOn: this.state.audit?.createdOn || null,
				updatedBy: this.state.audit?.updatedBy || null,
				updatedOn: this.state.audit?.updatedOn || null,
				onBehalfIdCompany: this.state.newAudit.onBehalfCompany?.id || null,
				onBehalfIdDivision: this.state.newAudit.onBehalfDivision?.id || null,
				onBehalfIdWorkSite: this.state.newAudit.onBehalfWorkSite?.id || null,
				onBehalfIdProject: this.state.newAudit.onBehalfProject?.id || null,
				processes: this.state.newAudit.processes.map((elem) => elem),
				functions: this.state.newAudit.functions.map((elem) => elem),
				subContractors: this.state.newAudit.subContractors.map((elem) => elem),
				auditScopeAndObjective: this.state.newAudit.auditScopeAndObjective,
				planAttachments: this.state.newAudit.planAttachments || [],
			};
			if (this.state.audit) {
				const auditors = this.state.audit?.auditors;
				auditors.shift();
				auditors.unshift(this.state.newAudit.auditor);
				const uniqAuditors = auditors.reduce((a, b) => {
					if (!a.find((c) => c.id === b.id)) a.push(b);
					return a;
				}, []);
				newAuditDTO.auditors = uniqAuditors;
				newAuditDTO.updatedBy = this.context.user.email;
				newAuditDTO.updatedOn = new Date();
				newAuditDTO.idCheckList = this.state.audit.idCheckList;
				newAuditDTO.checkList = this.state.audit.checkList || null;
				newAuditDTO.sequence = this.state.audit.sequence;
				newAuditDTO.reportSummary = this.state.audit.reportSummary;
				newAuditDTO.additionalNotes = this.state.audit.additionalNotes;
				newAuditDTO.startDate = this.state.audit.startDate;
				newAuditDTO.endDate = this.state.audit.endDate;
				newAuditDTO.reasonsForChange = this.state.newAudit.reasonsForChange;
				newAuditDTO.newCarManagement = this.state.audit.newCarManagement;
				newAuditDTO.maskedValue = this.state.audit.maskedValue;
				newAuditDTO.isMasked = this.state.audit.isMasked;
				await this.updateAudit(newAuditDTO);
			} else {
				newAuditDTO.createdBy = this.context.user.email;
				newAuditDTO.createdOn = new Date();
				newAuditDTO.updatedBy = this.context.user.email;
				newAuditDTO.updatedOn = newAuditDTO.createdOn;
				newAuditDTO.idStatus = 1;
				newAuditDTO.status = {
					id: 1,
					name: "Draft",
					planningName: "Draft",
					reportingName: "Opened",
					carManagementName: "Assigned",
				};
				await this.saveAudit(newAuditDTO);
			}
		} else {
			this.validator.showMessages();
			showNotification.warning(`${entitiesLabels.WARNING}`, `${entitiesLabels.AUDIT} required fields are missing  `);
			this.forceUpdate();
		}
	};

	getUsersInRole = (role, appModule, idWorksites, idDivision) => { //RITM1064131
		me.getWithParam("getuserbyroleandmodule", { //RITM1064131
			params: { role: role, appModule: appModule, idWorksites: idWorksites, IdDivision: idDivision, includeAdmins: true }, //RITM1064131
		})
			.then((response) => {
				this.setState({
					approvers: response.data,
					isLoadingApproverOptions: false,
				});
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.ROLE, apioperation.GET));
			})
			.finally(() => {
				this.setState({
					isLoadingApproverOptions: false,
				});
			});
	};


	// /Status Action
	handleApproverSelect = (selectedItem) => {
		this.setState({ approver: selectedItem });
	};

	handleCloseApprovalModal = () => {
		this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
	};

	handleApprovalNotesChange = (e) => {
		this.setState({ approvalNotes: e.target.value });
	};

	handleConfirmApprovalModal = () => {
		const apiEndpoint = this.state.approvalEndpoint;

		const data = {
			ids: [this.state.audit.id],
			owner: this.state.approver,
			workflowNotes: this.state.approvalNotes,
		};

		this.setState({
			isLoadingWFOperation: true,
		});
		api.put(`/audit/${apiEndpoint}`, data, "")
			.then((response) => {
				if (response.status === 200) {
					showNotification.success(`${entitiesLabels.SUCCESS}`, getSuccess(entitiesLabels.AUDIT, apioperation.PUT));
					this.setState({
						isLoadingWFOperation: false,
						isApprovalModalOpen: false,
						isSubmitted: true,
					});

					this.props.history.push("/listofaudit");
				} else {
					showNotification.error();
					this.setState({
						isLoadingWFOperation: false,
					});
				}
			})
			.catch((error) => {
				showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.AUDIT, apioperation.PUT));
				this.setState({
					isLoadingWFOperation: false,
				});
			})
			.finally(() => {});
	};

	batchActionClick(actionKey, actionName, approverRole, withApprover, approvalNotesRequired, selectedRows) {
		const audit = selectedRows;

		const idWorksites = audit.worksites?.map(el => el.id).join("|") || null; //RITM1064131
		const idDivision = audit.division.id; //RITM1064131

		//    actionKey == 'Submit' || actionKey == 'submitreport'
		//        ? audit.idWorksite
		//        : actionKey == 'Approve' || actionKey == 'approvereport'
		//            ? audit.idDivision
		//            : null;

		this.setState({
			approvalModalAction: actionName,
			isApprovalModalOpen: true,
			isLoadingApproverOptions: true,
			withApprover,
			selectedData: selectedRows,
			approverRole,
			approvalEndpoint: actionKey,
			approvalNotesRequired,
			statewf: audit.idStatus,
		});

		if (withApprover) this.getUsersInRole(approverRole, 'Audit', idWorksites, idDivision); //RITM1064131
	}

	renderHeader = () => (
		<>
			<PageBreadCrumb
				linkTo="/listofaudit?isBack"
				linkText="Audit List"
				titleLeft={this.state.audit ? "Edit Audit Program" : "New Audit Program"}
				titleCenter={this.state.audit && this.state.audit.auditCode ? `ID: ${this.state.audit.auditCode}` : ""}
				titleRight={this.state.audit ? this.state.audit.status.planningName : null}
				showButtonHistory={this.showButtonHistory()}
				batchActions={this.getStatusActions(this.context.user)}
			/>			
			<HistoryTable
				entityId={this.state.newAudit.id}
				isOpenModal={this.state.isHistoryModalOpen}
				onClose={() => this.closeModalHistory()}
				masked={this.state?.newAudit.maskedValue}
			/>
		</>
	);

	renderForm() {
		const validations = {
			// division: this.validator.message("division", this.state.newAudit.division.id, "required"), //RITM0945977
			division: this.validator.message("auditeeBusinessLine", this.state.newAudit.division.id, "required"),
			section: this.validator.message("Section", this.state.newAudit.section.id, "required"),
			type: this.validator.message("Audit Type", this.state.newAudit.type.id, "required"),
			scope: this.validator.message("Scope", this.state.newAudit.scopes[0], "required"),
			month: this.validator.message("month", this.state.newAudit.month, "required"),
			year: this.validator.message("year", this.state.newAudit.year, "required"),
			auditor: this.validator.message("auditor", this.state.newAudit.auditor.id, "required"),
			// onBehalfDivision: this.validator.message("onBehalfDivision", this.state.newAudit.onBehalfDivision ? this.state.newAudit.onBehalfDivision.id : "", "required"), //RITM0945977
			onBehalfDivision: this.validator.message("auditorBusinessLine", this.state.newAudit.onBehalfDivision ? this.state.newAudit.onBehalfDivision.id : "", "required"),
			target: this.validator.message("target", this.state.newAudit.target.id, "required"),
			distributionList: this.validator.message("distributionList", this.state.newAudit.distributionList, "required"),
			reasonsForSampling: this.validator.message("reasonsForSampling", !this.state.editingDisabled ? this.state.newAudit.reasonsForSampling[0] : true, "required"),
			process: this.validator.message(
				"processes",
				(this.state.newAudit.section?.id?.toLowerCase() == AuditSection.QUALITY.id?.toLowerCase() || this.state.newAudit.section?.id?.toLowerCase() == AuditSection.HSEQ.id?.toLowerCase() || this.state.newAudit.section?.id?.toLowerCase() == AuditSection.HSE.id?.toLowerCase()) && !this.state.editingDisabled
					? this.state.newAudit.processes[0]
					: true,
				"required"
			),
			//RITM0601430
			subContractors: this.validator.message("Subcontractor", this.state.newAudit.target.name === "Subconctractor/Supplier" ? this.state.newAudit.subContractors[0] : true, "required") 
		};

		return (
			<>
			<Loading active={this.state.isLoadingNotificationFile} withOverlay />
				{this.renderHeader()}
				<div className="mainContainer">
					<div className="bx--grid content full-width mainContainer ">
						<ScrollingProvider key="scroll_0">
							<div className="padding-progress-indicator-vertical hidden-box">
								<Menu>
									<Item section="auditdetails">Details of audit</Item>
									<Item section="auditeedetails">Details of auditee</Item>
									<Item section="auditordetails">Details of the Lead Auditor</Item>
									<Item section="disitributionlist">Distribution list</Item>									
								</Menu>
							</div>
							<div className="bx--col-lg-10 bx--col-md-10 margin-progress-indicator-vertical">
								<Section id="auditdetails" className="section--title">
									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel>Section *</FormLabel>
												<SectionComboBox
													invalid={validations.section != null}
													invalidText={validations.section}
													onChange={this.onSelectSectionChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.SECTION, apioperation.GET));
													}}
													selectedItem={this.state.newAudit.section}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel>Reference Date *</FormLabel>
												<div className="bx--row">
													<div className="bx--col-lg-6 bx--col-md-4">
														<ComboBox
															id="cmbReferenceYear"
															invalid={validations.year != null}
															invalidText={validations.year}
															placeholder="year"
															items={this.years}
															selectedItem={this.state.newAudit.year || null}
															onChange={this.handleSelectedYear}
															itemToString={(item) => item || ""}
															disabled={this.state.editingDateDisabled}
														/>
													</div>
													<div className="bx--col-lg-6 bx--col-md-4">
														<ComboBox
															id="cmbReferenceMonth"
															invalid={validations.month != null}
															invalidText={validations.month}
															placeholder="month"
															items={this.months}
															selectedItem={this.state.newAudit.month || null}
															onChange={this.handleSelectedMonth}
															itemToString={(item) => item || ""}
															disabled={this.state.editingDateDisabled}
														/>
													</div>
												</div>
											</FormGroup>
										</div>
									</div>
									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-6">
											<FormGroup>
												<FormLabel className="some-class">Audit Criteria *</FormLabel>
												<AuditScopeMultiSelect
													invalid={validations.scope != null}
													invalidText={validations.scope}
													onChange={this.onSelectScopeChange}
													section={this.state.newAudit.section.id}
													key={this.state.newAudit.section.id}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.SCOPE, apioperation.GET));
													}}
													initialSelectedItems={this.state.newAudit.scopes}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-6">
											<FormGroup>
												<FormLabel className="some-class">Audit Scope and Objective</FormLabel>
												<TextArea
													maxLength={5000}
													id="auditScopeAndObjective"
													placeholder="Audit Scope and Objective"
													value={this.state.newAudit.auditScopeAndObjective}
													hideLabel
													labelText=""
													light
													rows={1}
													cols={225}
													onChange={this.onAuditScopeObjectiveChange}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
									</div>

									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-6">
											<FormGroup>
												<FormLabel>Type of audit *</FormLabel>
												<AuditTypeComboBox
													invalid={validations.type != null}
													invalidText={validations.type}
													onChange={this.onSelectAuditTypeChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TYPEAUDIT, apioperation.GET));
													}}
													section={this.state.newAudit.section.id}
													key={this.state.newAudit.section.id}
													initialSelectedItem={this.state.newAudit.type}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class">Target *</FormLabel>
												<AuditTargetDropDown
													invalid={validations.target != null}
													invalidText={validations.target}
													onChange={this.onSelectTargetChange}
													openUp
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.TARGET, apioperation.GET));
													}}
													initialSelectedItem={this.state.newAudit.target}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
									</div>

									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-6">
											<FormGroup>
												<FormLabel className="some-class">Project Audit Code</FormLabel>
												<TextInput
													id="inputProjectAuditCode"
													placeholder="Project Audit Code"
													value={this.state.newAudit.projectAuditCode}
													labelText=""
													onChange={this.onProjectAuditCodeChange}
													onClick={() => {}}
													type="text"
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-6">
											<FormGroup>
												<FormLabel className="some-class">Audit in Remote Mode</FormLabel>
												<Checkbox
													id="isAuditRemote"
													alt="model"
													labelText=""
													checked={this.state.newAudit.auditRemote || false}
													onChange={this.onAuditRemoteChange}
												/>
											</FormGroup>
										</div>
									</div>

									{this.state.newAudit.section.id?.toLowerCase() == AuditSection.QUALITY.id.toLowerCase() || this.state.newAudit.section.id?.toLowerCase() == AuditSection.HSEQ.id.toLowerCase() ||  this.state.newAudit.section.id?.toLowerCase() == AuditSection.HSE.id.toLowerCase() ? (
										<div className="bx--row">
											<div className="bx--col-lg-6 bx--col-md-12">
												<FormGroup>
													<FormLabel>Processes *</FormLabel>
													<ProcessMultiSelect
														invalid={validations.process != null}
														invalidText={validations.process}
														onChange={this.onSelectProcessChange}
														onError={(error) => {
															showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.SCOPE, apioperation.GET));
														}}
														initialSelectedItems={this.state.newAudit.processes}
														disabled={this.state.editingDisabled}
													/>
												</FormGroup>
											</div>
											<div className="bx--col-lg-6 bx--col-md-12">
												<FormGroup>
													<FormLabel>Subprocesses</FormLabel>
													<FunctionMultiSelect
														onChange={this.onSelectFunctionChange}
														onError={(error) => {
															showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "Subprocesses", apioperation.GET));
														}}
														initialSelectedItems={this.state.newAudit}
														disabled={this.state.editingDisabled}
													/>
												</FormGroup>
											</div>
										</div>
									) : (
										""
									)}

									<div>
										{this.state.newAudit.target.name === "Subconctractor/Supplier" ? (
											<AuditSubcontractor
												invalid={validations.subContractors}
												invalidText={validations.subContractors}
												auditSubcontractors={this.state.newAudit.subContractors}
												onChange={this.onSelectSubContractorsChange}
												onError={(error) => {
													showNotification.error(`${entitiesLabels.ERROR}`, getError(error, "Subcontractor", apioperation.GET));
												}}
												disabled={this.state.editingDisabled}
												key={this.state.newAudit.id}
											/>
										) : (
											""
										)}
									</div>
								</Section>
								<Section id="auditeedetails">
									<div>
										<h3 className="title--medium--expressive">Details of the auditee</h3>
									</div>
									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												{/* RITM0945977 */}
												{/* <FormLabel className="some-class">Main Division *</FormLabel>  */}
												<FormLabel className="some-class">Auditee Business Line *</FormLabel> 
												<DivisionComboBox
													invalid={validations.division != null}
													invalidText={validations.division}
													onChange={this.onSelectDivisionChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.MAINDIVISION, apioperation.GET));
													}}
													selectedItem={this.state.newAudit.division}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class">Company</FormLabel>
												<CompanyComboBox
													onChange={this.onSelectCompanyChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.COMPANY, apioperation.GET));
													}}
													selectedItem={this.state.newAudit.company}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
									</div>
									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class worksite">Work Sites</FormLabel>
												<WorkSiteMultiSelect
													onChange={this.onSelectWorkSiteChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
													}}
													division={this.state.newAudit.division.id}
													key={this.state.newAudit.division.id + this.state.newAudit.worksites?.map(el => el.id)}
													initialSelectedItems={this.state.newAudit.worksites}
													disabled={this.state.editingWorkSiteDisabled}
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class worksite">Project</FormLabel>
												<ProjectMultiSelect
													onChange={this.onSelectProjectChange}
													company={this.state.newAudit.company?.id}
													key={this.state.newAudit.company?.id}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
													}}
													initialSelectedItems={this.state.newAudit.projects}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
									</div>
									<div className="bx--row">
										<div className="bx--col-lg-12 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class">Reasons For Sampling*</FormLabel>
												{this.state.editingDisabled == true ? (
													<ReasonForSamplingMultiSelect
														onChange={this.onSelectReasonChange}
														onError={(error) => {
															showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.REASONFORSAMPLING, apioperation.GET));
														}}
														openUp
														initialSelectedItems={this.state.newAudit.reasonsForSampling}
														disabled={this.state.editingDisabled}
														key={this.state.newAudit.id}
													/>
												) : (
													<ReasonForSamplingMultiSelect
														onChange={this.onSelectReasonChange}
														invalid={this.state.editingDisabled ? false : this.validator.message("reasonsForSampling", this.state.newAudit.reasonsForSampling[0], "required") != null}
														invalidText={this.state.editingDisabled ? "" : this.validator.message("reasonsForSampling", this.state.newAudit.reasonsForSampling[0], "required")}
														onError={(error) => {
															showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.REASONFORSAMPLING, apioperation.GET));
														}}
														openUp
														initialSelectedItems={this.state.newAudit.reasonsForSampling}
														disabled={this.state.editingDisabled}
														key={this.state.newAudit.id}
													/>
												)}
											</FormGroup>
										</div>
									</div>

									{this.state.newAudit.reasonsForSampling.findIndex((el) => el.name === "Any other HSE issues") !== -1 ? (
										<div className="bx--row">
											<div className="bx--col-lg-12 bx--col-md-12">
												<FormGroup legendText="Any Other HSE Issues">
													<TextArea
														maxLength={5000}
														labelText=""
														id="inputOtherHSEIssue"
														name="inputOtherHSEIssue"
														cols={100}
														disabled={false}
														invalid={false}
														light={false}
														placeholder=""
														rows={4}
														value={this.state.newAudit.otherHSEIssues || ""}
														onChange={(el) => this.onOtherHSEIssuesTextChange(el.target.value)}
													/>
													{validations.question}
												</FormGroup>
											</div>
										</div>
									) : (
										""
									)}
								</Section>
								<Section id="auditordetails">
									<div>
										<h3 className="title--medium--expressive">Details of the Lead Auditor</h3>
									</div>
									<div className="bx--row">
										<div className={this.state.checkListCompilerChanged == true ? "bx--col-lg-6 bx--col-md-12" : "bx--col-lg-12 bx--col-md-12"}>
											<FormGroup>
												<FormLabel className="some-class">{TEAM_LEADER} *</FormLabel>
												<AuditorComboBox
													division={this.state.newAudit.division?.id}
													invalid={validations.auditor != null}
													//key={this.state.newAudit.division?.id && this.state.userDivision} //B1_Audit_Module_Optimization
													key={this.state.newAudit.division?.id} 
													invalidText={validations.auditor}
													onChange={this.onSelectAuditorChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.AUDITOR, apioperation.GET));
													}}
													//userDivision={this.state.userDivision || []} //B1_Audit_Module_Optimization
													selectedItem={this.state.newAudit.auditor}
													disabled={this.state.editingAuditorDisabled || this.state.newAudit.maskedValue}
													maskedValue={this.state.newAudit.maskedValue} //RITM1133680
												/>
											</FormGroup>
										</div>
										{this.state.checkListCompilerChanged == true ? (
											<div className="bx--col-lg-6 bx--col-md-12">
												<FormGroup>
													<FormLabel className="some-class">Reason for change *</FormLabel>

													<TextInput
														id="inputReasonForChange"
														invalid={this.validator.message("Reasons for change", this.state.newAudit.reasonsForChange, "required") != null}
														invalidText={this.validator.message("Reasons for change", this.state.newAudit.reasonsForChange, "required")}
														labelText=""
														onChange={this.onReasonForChangeChange}
														onClick={() => {}}
														type="text"
													/>
												</FormGroup>
											</div>
										) : (
											""
										)}
									</div>
									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												{/* RITM0945977 */}
												{/* <FormLabel className="some-class">Division *</FormLabel> */}
												<FormLabel className="some-class">Auditor Business Line *</FormLabel>
												<OnBehalfDivisionComboBox
													invalid={validations.onBehalfDivision != null}
													invalidText={validations.onBehalfDivision}
													onChange={this.onBehalfDivisionChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.MAINDIVISION, apioperation.GET));
													}}
													selectedItem={this.state.newAudit.onBehalfDivision ? this.state.newAudit.onBehalfDivision : {}}
													disabled={
														(this.state.audit?.onBehalfDivision ?	this.state.audit.onBehalfDivision.hasOwnProperty('id') :
																								false
														)&& this.state.editingDisabled
													}
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class worksite">Work Site</FormLabel>
												<OnBehalfWorkSiteComboBox
													onChange={this.onBehalfWorkSiteChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.WORKSITE, apioperation.GET));
													}}
													division={this.state.newAudit.onBehalfDivision?.id}
													key={this.state.newAudit.onBehalfDivision?.id}
													selectedItem={this.state.newAudit.onBehalfWorkSite}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
									</div>
									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class">Company</FormLabel>
												<CompanyComboBox
													onChange={this.onBehalfCompanyChange}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.COMPANY, apioperation.GET));
													}}
													selectedItem={this.state.newAudit.onBehalfCompany}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class worksite">Projects</FormLabel>
												<OnBehalfProjectComboBox
													onChange={this.onBehalfProjectChange}
													company={this.state.newAudit.onBehalfCompany?.id}
													key={this.state.newAudit.onBehalfCompany?.id}
													onError={(error) => {
														showNotification.error(`${entitiesLabels.ERROR}`, getError(error, entitiesLabels.PROJECT, apioperation.GET));
													}}
													selectedItem={this.state.newAudit.onBehalfProject}
													disabled={this.state.editingDisabled}
												/>
											</FormGroup>
										</div>
									</div>
								</Section>
								<Section id="disitributionlist">
									<div>
										<h3 className="title--medium--expressive">Distribution list (Personal Email Addresses are not Allowed)</h3>
									</div>
									<div className="bx--row">
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class">Mail To*</FormLabel>
												<EmailChips
													id="inputDistributionList"
													title="&#9888; Do not use Personal Accounts"
													invalid={validations.distributionList != null}
													// invalidText={validations.distributionList}
													value={this.state.newAudit.distributionList || ""}
													disabled={this.state.editingDisabled}
													type="text"
													onChange={this.onSelectDistributionListChange}
													masked={this.state.newAudit.maskedValue}
													//RITM1133680 Start - Anonimization AUDIT Module
												/>
											</FormGroup>
										</div>
										<div className="bx--col-lg-6 bx--col-md-12">
											<FormGroup>
												<FormLabel className="some-class">Mail CC</FormLabel>
												<EmailChips
													id="inputMailCC"
													// invalid={validations.distributionList != null}
													// invalidText={validations.distributionList}
													value={this.state.newAudit.mailCC || ""}
													disabled={this.state.editingDisabled}
													type="text"
													title="&#9888; Do not use Personal Accounts"

													onChange={this.onSelectMailCCChange}
													masked={this.state.newAudit.maskedValue}
													//RITM1133680 Start - Anonimization AUDIT Module
												/>
											</FormGroup>
										</div>
									</div>
								</Section>
								
							</div>
						</ScrollingProvider>
					</div>
					<div className="bx--col-lg-12 bx--col-md-12 main-information-button">
						<Button
							size="default"
							renderIcon={Save16}
							kind="primary"
							disabled={this.state.editingDisabled && this.state.editingAuditorDisabled && this.state.editingDateDisabled && this.state.editingWorkSiteDisabled}
							onClick={this.handleSubmit}
						>
							Save
						</Button>
					</div>
					{this.renderLoadingModal()}
				</div>
				<WFActionModal
					show={this.state.isApprovalModalOpen}
					title={`${this.state.approvalModalAction} Audit`}
					action={this.state.approvalModalAction}
					withApprover={this.state.withApprover}
					approver={this.state.approver}
					approverRole={this.state.approverRole}
					approverOptions={this.state.approvers}
					isLoadingOperation={this.state.isLoadingWFOperation}
					onApproverSelect={this.handleApproverSelect}
					isLoadingOptions={this.state.isLoadingApproverOptions}
					onCancel={this.handleCloseApprovalModal}
					onConfirm={this.handleConfirmApprovalModal}
					onApprovalNotesChange={this.handleApprovalNotesChange}
					approvalNotes={this.state.approvalNotes}
					approvalNotesRequired={this.state.approvalNotesRequired}
					validationMessages={this.state.approvalValidationMessages}
					user={this.context.user} //RITM1064131
				/>
			</>
		);
	}

	render() {
		return <AppContext.Consumer>{({ user }) => (IsEnabled(user, "Audit") ? this.renderForm(user) : "")}</AppContext.Consumer>;
	}
}
AuditProgram.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			id: PropTypes.string,
		}),
	}),
};
AuditProgram.defaultProps = {};
AuditProgram.contextType = AppContext;
